'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Stack, Typography } from '@mui/material';
import Image from 'next/image';
import { signIn } from 'next-auth/react';
import { WelcomePageWrapper } from '@/app/(blank-layout-pages)/welcomePageWrapper';
const LoginV1 = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      gap: "40px",
      overflow: "hidden",
      width: "680px",
      maxWidth: "100%"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Typography variant="h1" sx={{
      maxWidth: "540px",
      wordWrap: "break-word"
    }}>Log in to your account</Typography>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image src="/statics/images/logos/google.png" alt="Google" width={22} height={22} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <WelcomePageWrapper><Stack sx={t0}>{t1}<Button variant="outlined" data-testid="login-google-button" startIcon={t2} sx={{
          alignSelf: "flex-start",
          color: "var(--mui-palette-text-primary)",
          "& .MuiButton-startIcon": {
            marginInlineEnd: "12px"
          }
        }} onClick={_temp}>Sign in with Google</Button></Stack></WelcomePageWrapper>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export { LoginV1 };
function _temp() {
  return void signIn("google");
}